const uz = {
  AuthTitle: {
    Greetings: "Xush kelibsiz",
  },
  Auth: {
    EnterEmail: "Elektron pochtani kiriting",
    EnterPassword: "Parolni kiriting",
    AgreeWith: "Men roziman",
    ProcessingPersonalData: "shaxsiy ma'lumotlarni qayta ishlash",
    UserAgreement: "foydalanuvchi shartnomasi",
    EmailRequiredError: "Elektron pochta kerak",
    EmailWrongFormatError: "Noto'g'ri elektron pochta formati",
    PasswordRequiredError: "Parol talab qilinadi",
    ForgotPassword: "Parolni unutdingizmi?",
  },
  Login: {
    Title: "Ruxsat",
    Subtitle: "Hisobingizga kirish uchun quyidagi maydonlarni to'ldiring.",
    Login: "Kirish",
    Register: "Roʻyxatdan oʻtish",
    LoginError: "Noto'g'ri login yoki parol kiritilgan",
    BuyTeacherLessons: "O'qituvchi bilan darslarni sotib olish",
  },
  Register: {
    Title: "Roʻyxatdan oʻtish",
    Subtitle:
      "Hisob qaydnomangizni ro'yxatdan o'tkazish uchun quyidagi maydonlarni to'ldiring.",
    Register: "Ro'yxatdan o'tish",
    Login: "Kirish",
    EnterLastName: "Familiyani kiriting",
    EnterFirstName: "Ismni kiriting",
    EnterEmail: "Elektron pochtani kiriting",
    EnterGender: "jins",
    EnterBirthday: "tug'ilgan sana",
    EnterProfileCountryId: "Fuqarolik",
    EnterProfileCityId: "Mezbon shahar",
    EnterProfileDegreeId: "Ta'lim",
    EnterPassword: "Parolni kiriting",
    RepeatPassword: "Parolni takrorlash",
    LastNameRequiredError: "Familiya kerak",
    LastNameMinLengthError: "Minimal 2 ta belgi",
    FirstNameRequiredError: "Ism kerak",
    FirstNameMinLengthError: "Minimal 2 ta belgi",
    PhoneRequiredError: "Telefon kerak",
    PhoneInvalidError: "Telefon formati noto'g'ri",
    GenderRequiredError: "Jins shart",
    BirthdayRequiredError: "Tug'ilgan sana kerak",
    ProfileCountryIdRequiredError: "Fuqarolik kerak",
    ProfileCityIdRequiredError: "Qabul qiluvchi shahar talab qilinadi",
    ProfileDegreeIdRequiredError: "Ta'lim kerak",
    PasswordMismatchError: "Parollar mos kelmaydi",
    PasswordMinLengthError: "Minimal 6 ta belgi",
  },
  Reset: {
    Title: "Parolni tiklash",
    Subtitle:
      "Ro'yxatdan o'tish paytida taqdim etgan elektron pochta manzilingizni kiriting va \"Qayta tiklash\" tugmasini bosing.",
    Reset: "Qayta tiklash",
    Login: "Kirish",
    Success:
      "Bir necha daqiqa ichida siz <0>{{email}}</0> manziliga parolingizni qanday tiklash bo'yicha ko'rsatmalar bilan elektron pochta xabarini olasiz.",
  },
  CookieNotice: {
    Message:
      "Biz sayt va uning foydalanuvchi tajribasini yaxshilash uchun cookie-fayllardan foydalanamiz. Saytdan foydalanishni davom ettirish orqali siz cookie-fayllardan foydalanishga rozilik bildirasiz. Siz har doim brauzer sozlamalarida cookie-fayllarni o'chirib qo'yishingiz mumkin.",
    Agree: "Qabul qiling, boshqa ko'rsatmang",
  },
  MainPage: {
    Title: "Bosh sahifa",
    TitleGreetings: "Xush kelibsiz",
    TitleGreetingsMiddle: "GOVORI",
    TitleGreetingsEnd: "RU!",
    MyCourses: "Mening kurslarim",
    CourseContinue: "DAVOM ETISH",
    CourseCountStart: "Mavjud",
    CourseCount: "{{count}} ta kurs",
    AllCourses: "Barcha kurslar",
    MyLessons: "Mening darslarim",
    AllLessons: "barcha darslar",
    EmptyCourses: "Kurslar yo'q",
    EmptyLessons: "Dars yo'q",
    BuyTeacherLessons: "O'qituvchi bilan darslarni sotib olish",
    BuyTeacherLessonsLink: "bu yerda",
    ForeignCardTooltip:
      "Rossiya Federatsiyasidan tashqarida chiqarilgan kartalar uchun",
    NoActiveLicense: "Sizda faol litsenziya yo'q.",
    GoIntoLesson: "Darsga",
    FinishedLessons: "O'tkazilgan",
    CanceledLessons: "BEKOR ETILGAN",
  },
  CoursesPage: {
    Title: "Kurslar",
    TitleGreetings: "Xush kelibsiz",
    MyCourses: "Mening kurslarim",
    CourseContinue: "DAVOM ETISH",
    EmptyCourses: "Kurslar yo'q",
    SearchPlaceholder: "Nomi bo'yicha qidirish",
    LevelPlaceholder: "Daraja",
    AllLevels: "Barcha darajalar",
  },
  Menu: {
    Main: "Asosiy sahifa",
    Words: "So'zlar",
    Courses: "Mening kurslarim",
    Lessons: "O'qituvchi bilan darslar",
    TeacherCorner: "O'qituvchi burchagi",
    AdditionalCourses: "Qo'shimcha kurslar",
    UsefulLinks: "Foydali havolalar",
    Notifications: "Bildirishnomalar",
    Video: "Video",
    TeacherGroups: "Guruhlar",
    TeacherAttendance: "Davomat",
    TeacherClasses: "Sinflar",
    TeacherReports: "Hisobotlar",
    CreativeTasks: "Ijodiy vazifalar",
    Attendance: "Davomat",
  },
  Footer: {
    Copyright: "Barcha huquqlar himoyalangan",
    About: "Kompaniya haqida",
    PrivacyPolicy: "Ma'lumotlardan foydalanish siyosati",
    PrivacyProtect:
      "Shaxsiy ma'lumotlarni qayta ishlash va himoya qilish qoidalari",
  },
  Module: {
    Completed: "Yaratilgan",
    Result: "Natija",
    InWork: "Ishda",
    Done: "Bajarildi",
  },
  SteppedProgress: {
    Completed: "Bajarildi",
  },
  CourseDetails: {
    Title: "Kurs haqida ma'lumot",
    Progress: "Taraqqiyot",
    Completed: "BAJARILDI",
    Result: "NATIJA",
    Hours: "Soat",
    Lessons: "Darslar",
    Units: "Birliklar",
    Unit: "Unit",
    Exercises_zero: "{{count}} ta mashq",
    Exercises_one: "{{count}} mashq",
    Exercises_other: "{{count}} mashqlar",
    Exercises_many: "{{count}} mashqlar",
  },
  CourseUnitDetails: {
    Vocabulary: "So'zlar",
    Video: "Video",
    Grammar: "Grammatika",
    Reading: "O'qish",
    Writting: "Xat",
    Speaking: "Gaplash",
    Test: "Test",
    Unknown: "Noma'lum",
    EmptyExercises: "Jismoniy mashqlar yo'q",
  },
  EntranceTest: {
    ModalTitle: "Bilim darajasini aniqlang",
    ModalBody:
      "Rus tilini bilish darajangizni aniqlash uchun testdan o'ting. Sinov o'rtacha 40 daqiqa davom etadi.",
    Cancel: "Bekor qilish",
    Take: "Vazifaga o'ting",
  },
  TeacherPage: {
    Title: "Bosh o'qituvchi",
    MyLessons: "Mening darslarim",
    MyModuless: "Mening modullarim",
  },
  DistributorPage: {
    Title: "Distribyutor uyi",
  },
  CoordinatorPage: {
    Title: "Uy koordinatori",
  },
  Button: { Send: "Yuborish", Download: "Yuklab olish" },
  Distributor: {
    Report: "Hisobotlar",
    DateFrom: "Sanadan boshlab",
    DateTo: "Sana bo'yicha",
    Status: "Holat",
    StatusReady: "Tayyor",
    StatusPlanned: "Qayta ishlash",
    Actions: "Harakatlar",
    FromRequiredError: "Boshlanish sanasini kiriting",
    ToRequiredError: "Tugash sanasini belgilang",
  },
  LessonsTable: {
    GroupName: "guruhlar",
    Status: "holat",
    StartDateTime: "Sana va vaqt",
    Duration: "ah",
    Credentials: "Vebinar: Login/Parol",
    CredentialsCopied: "Nusxa olindi!",
    SortAlpabetically: "Alifbo tartibida A dan Z gacha",
  },
  LessonStatuses: {
    completed: "Bajarildi",
    planned: "rejalashtirilgan",
    earlyCanceledByCustomer: "Tinglovchilar tomonidan bekor qilingan",
    earlyCanceledBySchool: "O'qituvchi bekor qilindi",
    lateCanceledByCustomer: "Tinglovchilar tomonidan bekor qilingan",
    lateCanceledBySchool: "O'qituvchi bekor qilindi",
  },
  LessonAttendance: {
    Status: "Statusni tanlang",
    Date: "Sanani tanlang",
    Time: "Vaqtni tanlang",
    Duration: "Davomiylik",
    AH: "a.s",
    Students: "O'quvchilar",
    CheckAll: "Hammani belgilang",
    Comment: "Izohlar",
    Submit: "Yuborish",

    restritiveBackDateError:
      "Sana ruxsat etilgan sanadan kam bo'lishi mumkin emas",
    restritiveForwardDateError:
      "Sana ruxsat etilganidan kattaroq bo'lishi mumkin emas",
    commentSizeError: "Izoh {{count}} ta soʻzdan kam boʻlishi kerak",
    requiredFieldError: "Bu maydon kerak",
    requiredDateError: "Iltimos, sana va vaqtni kiriting",
    ExcessHoursWarning: "Soatlar soni oshib ketdi",
    MarkStudents:
      "Darsga qatnashgan talabalarni belgilang va o'zgarishlarni saqlang.",

    apiError:
      "O'zgartirishlaringiz saqlanmadi. Iltimos, online@dschool.ru manziliga yozing",
    early_cancel_by_customer_not_acceptable:
      "Foydalanuvchi tomonidan erta bekor qilish mumkin emas, 2 ta dars allaqachon bekor qilingan, koordinator bilan bog'laning",
    early_cancel_by_school_not_acceptable:
      "Maktab tomonidan erta bekor qilish mumkin emas, 2 ta dars allaqachon bekor qilingan, koordinator bilan bog'laning",
  },
  TeacherReportsPage: {
    Title: "Отчёты",
    HeaderTitle: "Отчёты",
    CreateReport: "создать отчет",
  },
  TeacherReportTable: {
    Title: "Название отчета",
    CreationDate: "Дата создания",
    Period: "Период",
    Status: "Статус",
    StatusDone: "готово",
    StatusPending: "построение",
    Actions: "Действия",
    Statistics: "Статистика по платформе",
    CourseProgress: "Прогресс по курсу",
    ActiveTime: "Platforma hisobotidagi vaqt",
    EntranceTest: "Входное тестирование",
    LecenseReport: "Отчет по использованным лицензиям",
    HeaderTitle: "Отчеты",
    CreateReport: "Создать отчет",
    DeleteReport: "Вы уверены?",
    DeleteTooltip: "Удалить",
    MailTooltip: "Отправить на email",
    DownloadTooltip: "Скачать",
    DeleteGroupTooltip: "Удалить выбранные",
    MailGroupTooltip: "Отправить выбранные на email",
    DownloadGroupTooltip: "Скачать выбранные",
  },
  CreateReportForm: {
    Statistics: "Platforma statistikasi",
    CourseProgress: "Kursning borishi",
    ActiveTime: "Platforma hisobotidagi vaqt",
    Report: "Mening hisobotim",
    Title: "Hisobot yaratish",
    Type: "Hisobot turi",
    TypeLabel: "Turi",
    NameLabel: "Ism",
    DateLabel: "Sana",
    DateFromLabel: "Kimdan",
    DateToLabel: "Tomonidan",
    Name: "Hisobot nomi",
    Period: "Davr",
    PeriodFrom: "Dan",
    PeriodTo: "Uchun",
    Date: "Sana",
    FilterListGroup: "Guruh",
    FilterListStudent: "Talaba",
    FilterListCompany: "Mijoz kompaniyasi",
    FilterListTest: "Kirish testi nomi",
    FilterListSelectedStudents: "Guruh filtri, tanlangan {{count}} talaba",
    FilterListSelectedGroups: "Guruh filtri, tanlangan {{count}} ta guruh",
    FilterListSelectedCompanies:
      "Guruh filtri, tanlangan {{count}} ta kompaniya",
    FilterListSelectedTests:
      "Guruh filtri, tanlangan {{count}} ta kirish testi",
    FilterListSelectedPlaceholderStudents: "Talabalarni tanlang",
    FilterListSelectedPlaceholderGroups: "Tanlangan guruhlar",
    FilterListSelectedPlaceholderCompanies: "Tanlangan mijozlar kompaniyalari",
    FilterListSelectedPlaceholderTests: "Kirish testlarini tanlang",
    GroupsChosen: "Tanlangan guruhlar",
    ChooseAll: "Hammasini belgilash",
    RemoveAll: "Hammasini olib tashlang",
    GroupName: "Guruh",
    GroupDefault: "Guruh standarti",
    Cancel: "Bekor qilish",
    Create: "Yaratmoq",
    TitleRequiredError: "Ism talab qilinadi",
    FromRequiredError: "Davr boshlanish sanasi talab qilinadi",
    ToRequiredError: "Davr tugash sanasi talab qilinadi",
    GroupsRequiredError: "Bir yoki bir nechta guruhni tanlang!",
    OrderCreateError: "Yangi hisobot yaratib bo‘lmadi",
    FieldRequiredError: "Maydonni kiritish shart",
    NoItems: "Guruhlar yoʻq",
  },
  Gender: {
    Male: "Erkak",
    Female: "Ayol",
  },
  Role: {
    student: "Talaba",
    teacher: "O'qituvchi",
    distributor: "Distribyutor",
    coordinator: "Koordinator",
  },
  EmailNotConfirmed: {
    Title:
      "Platformaga kirish uchun {{email}} elektron pochta manzilingizga xat yuborildi. Iltimos, manzilingizni tasdiqlang. Agar sizda biron bir savol bo'lsa, onlayn@dschool.ru yozing",
    Back: "<< Qaytish",
  },
  MyWordsPage: {
    Title: "Mening so'zlarim",
    EmptyWordList:
      "O'rganish uchun so'zlar yo'q. Filtrlarda boshqa birlikni tanlang",
  },
  WordsFilter: {
    Title: "Filtrlar",
    Clear: "Tozalash",
    EmptyCourses: "Bo'sh kurslar",
    ChooseCourse: "Kursni tanlang",
    ChooseUnit: "Birlikni tanlang",
    EmptyUnits: "Bo'sh birliklar",
  },
  SetupPassword: {
    Title: "Parol o'rnatish",
    Subtitle:
      "Siz yangi parol o'rnatishingiz, yangi parolni kiritishingiz va quyidagi maydonlarga tasdiqlashingiz kerak",
  },
  SetupPasswordRedirect: {
    Title: "Harakat talab qilinadi",
    Description:
      "Ushbu xizmatdan foydalanishni davom ettirish uchun parol o'rnatishingiz kerak.",
    Redirect: "Parolni o'rnating",
  },
  ChangePassword: {
    Password: "Parol",
    PasswordRepeat: "Parolni tasdiqlash",
    Confirm: "Tasdiqlang",
    PasswordShortError: "Parol uzunligi 6 ta belgidan oshmasligi kerak",
    PasswordMismatch: "Parollar bir xil bo'lishi kerak",
    Success: "Parol muvaffaqiyatli o'zgartirildi",
    Login: "Avtorizatsiya sahifasiga",
  },
  ProfilePage: {
    Sarlavha: "Mening profilim",
  },
  Profile: {
    PersonalData: "Shaxsiy ma'lumotlar",
    FirstName: "Ism",
    LastName: "Familiya",
    BirthDate: "tug'ilgan sana",
    Citizenship: "Fuqarolik",
    Degree: "Ta’lim",
    City: "Kerish shahri",
    NewPassword: "Yangi parol",
    ConfirmNewPassword: "Yangi parolni tasdiqlang",
    Password: "Parol",
    Save: "Saqlash",
    DataUpdateSuccess: "Ma'lumotlar muvaffaqiyatli yangilandi",
    Settings: "Sozlamalar",
    ShowPassingResults: "O'tish natijasini ko'rsating",
  },
  UsefulLinks: {
    Title: "Foydali havolalar",
    GroupName: "O'quv guruhi:",
    Added: "Qo'shilgan",
    NoLinks: "Havolalar yo'q",
  },
  DatePicker: {
    Today: "Bugun",
    Clear: "Toza",
  },
  Promocode: {
    Expired:
      "Guruhga ro'yxatdan o'tish to'xtatildi. Menejeringizga murojaat qiling",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "Hech qanday o'qituvchi topilmadi",
    SelectTeacher: "O'qituvchining tanlovi",
  },
  Loading: {
    Error: "Yuklashda xato, sahifani yangilab ko‘ring",
  },
  MultipleSelect: {
    SelectAll: "Hammasini tanlang",
  },
  Attendance: {
    Title: "Davomat",
  },
};

export default uz;
